/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {LottiePositionKeyFrameModel} from "@/lib/lottie/animatedProperties/lottiePositionKeyframeModel";
import {TIntBoolean} from "@/lib/lottie/helpers/intBoolean";

export class LottiePositionModel extends JsonModel<LottiePositionModel.TJson> {
  public forceAnimateWithKeyFrames(keyframes: LottiePositionKeyFrameModel.IJson[]): this {
    if (!this.json.a) {
      return this.update({a: 1, k: keyframes});
    } else {
      return this.update({a: 1, k: [...this.json.k, ...keyframes]});
    }
  }

  public offsetPositionBy(offsetX: number, offsetY: number): this {
    if (!this.json.a) {
      const [x, y, z] = this.json.k;

      return this.update({k: [x + offsetX, y + offsetY, z]});
    } else {
      return this.update({
        k: this.json.k.map(
          (keyframe): LottiePositionKeyFrameModel.IJson => ({
            ...keyframe,
            s: keyframe.s.map((value, index) => {
              if (index === 0) {
                return value + offsetX;
              } else if (index === 1) {
                return value * offsetY;
              } else {
                return value;
              }
            }),
          })
        ),
      });
    }
  }

  public scale(scaleX: number, scaleY: number): this {
    if (!this.json.a) return this;

    return this.update({
      k: this.json.k.map((keyframe) => ({
        ...keyframe,
        s: keyframe.s.map((value, index) => {
          if (index === 0) {
            return value * scaleX;
          } else if (index === 1) {
            return value * scaleY;
          } else {
            return value;
          }
        }),
      })),
    });
  }

  public adjustTimingBy(factor: number): this {
    if (!this.json.a) return this;

    return this.update({k: this.json.k.map((keyframe) => ({...keyframe, t: keyframe.t * factor}))});
  }

  public offsetTimingBy(offset: number): this {
    if (!this.json.a) return this;

    return this.update({
      k: this.json.k.map((keyframe) => ({...keyframe, t: keyframe.t + offset})),
    });
  }
}

export namespace LottiePositionModel {
  export type TJson = IStaticAnimatedPropertyJson | IKeyframeAnimatedPropertyJson;

  export interface IBaseJson {
    /**
     * Property Index
     */
    ix?: number;

    /**
     * Whether the property is animated
     * @default 0
     */
    a?: TIntBoolean;

    /**
     * Expression
     */
    x?: string;

    /**
     * Length
     * Number of components in the value arrays.
     * If present values will be truncated or expanded to match this length when accessed from expressions.
     */
    l?: number;
  }

  export interface IStaticAnimatedPropertyJson extends IBaseJson {
    a?: 0;
    k: number[];
  }

  export interface IKeyframeAnimatedPropertyJson extends IBaseJson {
    a: 1;
    k: LottiePositionKeyFrameModel.IJson[];
  }
}
/* v8 ignore stop */
